var _defs, _path, _path2, _rect, _rect2, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.4,425.4c22.5-3.6,25.7,28.3,6.5,31.5-22.5,3.6-25.7-28.3-6.5-31.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M415.3,44.9H96.7c-28.6,0-51.8,23.2-51.8,51.8v318.6c0,28.6,23.2,51.8,51.8,51.8h318.6c28.6,0,51.8-23.2,51.8-51.8V96.7c0-28.6-23.2-51.8-51.8-51.8ZM416.3,413.7H96.1v-252.9h320.3v252.9Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 142.8,
    y: 229.6,
    width: 96.2,
    height: 46.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 142.8,
    y: 323,
    width: 96.2,
    height: 46.7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "279.8 229.6 314.6 229.6 339.4 206.6 373.3 239.6 335.7 276.3 279.8 276.3 279.8 229.6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "279.8 321.2 314.6 321.2 339.4 298.3 373.3 331.3 335.7 367.9 279.8 367.9 279.8 321.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQna);
export default __webpack_public_path__ + "static/media/qna.7fbd4e43c93b36aef52df8f1a803a119.svg";
export { ForwardRef as ReactComponent };